import { paths } from '@src/constants/pathsEnum';

export const nav = [
  {
    label: 'Services',
    depth: 2,
    webinars: [
      {
        title: 'Webinar',
        subtitle: 'Reliability in microservices environments using graceful degradation',
        link: 'https://events.codilime.com/reliability-in-microservices-environments-using-graceful-degradation?mtm_campaign=webinar_reliability_in_microservices&mtm_source=menu',
        background: 'linear-gradient(245.77deg, #44DCEC -1.3%, #05868E 31.12%, #062338 98.04%)',
      },
      {
        title: 'Resources',
        subtitle: 'Free knowledge at your fingertips',
        link: paths.RESOURCES.BASE,
        background:
          'linear-gradient(33.5deg, #FFFFFF -12%, rgba(163, 237, 0, 0.74) 6.2%, #00A2B8 33.56%, #174867 81.71%, #174867 122.27%)',
      },
    ],
    menu: [
      {
        label: 'DESIGN',
        menu: [
          {
            label: 'UX/UI services',
            link: paths.SERVICES.UX_UI_DESIGN,
          },
          {
            label: 'Product design',
            link: paths.SERVICES.PRODUCT_DESIGN,
          },
        ],
      },
      {
        label: 'SOFTWARE ENGINEERING',
        menu: [
          {
            label: 'Frontend',
            link: paths.SERVICES.FRONTEND,
          },
          {
            label: 'Backend',
            link: paths.SERVICES.BACKEND,
          },
          {
            label: 'Low-level engineering',
            link: paths.SERVICES.LOW_LEVEL,
          },
          {
            label: 'DevOps',
            link: paths.SERVICES.DEVOPS,
          },
          {
            label: 'Test automation',
            link: paths.SERVICES.TEST_AUTOMATION,
          },
        ],
      },
      {
        label: 'NETWORK & CLOUD ENGINEERING',
        menu: [
          {
            label: 'Network professional services',
            link: paths.SERVICES.NETWORK_PROFESSIONAL_SERVICES,
          },
          {
            label: 'Network solution services',
            link: paths.SERVICES.NETWORK_SOLUTION_SERVICES,
          },
        ],
      },
      {
        label: 'DATA ANALYTICS',
        menu: [
          {
            label: 'Data engineering',
            link: paths.SERVICES.DATA_ENGINEERING,
          },
        ],
      },
      {
        label: 'RESEARCH AND DEVELOPMENT',
        menu: [
          {
            label: 'R&D',
            link: paths.SERVICES.R_D,
          },
        ],
      },
      {
        label: 'FOR STARTUPS',
        menu: [
          {
            label: 'Fast-Track Demo',
            link: paths.FAST_TRACK_DEMO,
          },
          {
            label: 'MVP software development',
            link: paths.SERVICES.MVP,
          },
          {
            label: 'Software development for startups',
            link: paths.SERVICES.SOFTWARE_DEVELOPMENT,
          },
        ],
      },
    ],
  },
  {
    label: 'Technologies',
    link: paths.TECHNOLOGIES,
  },
  {
    label: 'Knowledge',
    depth: 2,
    webinars: [
      {
        title: 'Webinar',
        subtitle: 'Reliability in microservices environments using graceful degradation',
        link: 'https://events.codilime.com/reliability-in-microservices-environments-using-graceful-degradation?mtm_campaign=webinar_reliability_in_microservices&mtm_source=menu',
        background: 'linear-gradient(245.77deg, #44DCEC -1.3%, #05868E 31.12%, #062338 98.04%)',
      },
    ],
    menu: [
      {
        label: 'EXPERTISE',
        menu: [
          {
            label: 'Blog',
            link: paths.BLOG,
          },
          {
            label: 'Resources',
            link: paths.RESOURCES.BASE,
          },
        ],
      },
      {
        label: 'OUR WORK',
        menu: [
          {
            label: 'Case studies',
            link: paths.CASE_STUDIES.HOME,
          },
        ],
      },
      {
        label: 'NEWS',
        menu: [
          {
            label: 'Newsroom',
            link: paths.NEWS,
          },
          {
            label: 'Newsletter',
            link: paths.NEWSLETTER,
          },
        ],
      },
    ],
  },
  {
    label: 'About',
    link: paths.ABOUT,
  },
  {
    label: 'Careers',
    link: paths.CAREERS,
  },
].map(linkify());

function linkify(prefix = '') {
  return ({ link, menu, ...rest }) => ({
    link: link ? prefix + link : undefined,
    menu: menu ? menu.map(linkify(link ? prefix + link : prefix)) : undefined,
    ...rest,
  });
}

export const allNavURLS = nav.map(function flatURL({ link, menu }) {
  return [link, ...(menu || []).map(flatURL).flat(1)].filter(Boolean);
});
